import { CheckBox, CheckBoxOutlineBlank, Padding } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Checkbox,
  CircularProgress,
  Collapse,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { OrderContext } from "../contexts/OrderContext";
import axios from "axios";
import { ReactComponent as LinkIcon } from "../assets/img/icons/Link.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

function CreateFilterLink() {
  let IMAGE_BASE_URL = "";
  const { storeData } = useContext(OrderContext);
  const navigate = useNavigate();

  const [editLinkInfo, setEditLinkInfo] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loadingLinkData, setLoadingLinkData] = useState(false);

  const location = useLocation();
  const linkPrivacy = location?.state?.link_privacy;

  useEffect(() => {
    if (location.state?.link_id) {
      setEditLinkInfo(location.state.link_id);
    }
  }, [location.state]);

  const {
    itemtypes = [],
    designs = [],
    screwTypes = [],
    finishtypes = [],
    storeInfo = [],
    customers = [],
  } = storeData;

  const selectedManufacturer = JSON.parse(localStorage.getItem("selectedMfr"));
  const mfrId = selectedManufacturer?.id;

  if (Array.isArray(storeInfo) && storeInfo.length > 0) {
    const { mail_id, url_prefix } = storeInfo[0];
    IMAGE_BASE_URL = `https://kumuduorderapp.blob.core.windows.net/${url_prefix}/`;
  } else {
    console.log("No store information found.");
  }

  const [filters, setFilters] = useState({
    itemType: "",
    design: "",
    collection: "",
    floor: "",
    grossWtMin: "",
    grossWtMax: "",
    netWtMin: "",
    netWtMax: "",
    finishtype_id: "",
    screw_type_id: "",
    from_date: "",
    to_date: "",
    expiryDate: "",
    imageFilter: "all",
    store_id: mfrId,
  });
  const [groups, setGroups] = useState([]); // List of all user groups

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [stockData, setStockData] = useState([]);
  const [selectedTagNos, setSelectedTagNos] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // const [imageFilter, setImageFilter] = useState("all");
  const [posibleTagNos, setPosibleTagNos] = useState(null);
  const [linkType, setLinkType] = useState("Public");
  const [selectedGroup, setSelectedGroup] = useState([]); // selected users
  const [brands, setBrands] = useState([]);
  const [floors, setFloors] = useState([]);
  const [collections, setCollections] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [linkName, setLinkName] = useState("");
  const [isSet, setIsSet] = useState(false);
  const [isExhibition, setIsExhibition] = useState(false);
  const [expiryDate, setExpiryDate] = useState(""); // optional date field for expiry
  const [loading, setLoading] = useState(false);

  // Fetch link info
  useEffect(() => {
    const fetchLinkData = async () => {
      if (location.state?.link_id) {
        setEditLinkInfo(location.state.link_id);
        setIsEditMode(true);
        setLoadingLinkData(true);

        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/auth/links/link/${location.state.link_id}`,
          );

          if (response.data.success) {
            const linkData = response.data.data;

            setLinkName(linkData.name);
            setLinkType(linkData.type === "public" ? "Public" : "Private");

            if (linkData.expiryDate) {
              const date = new Date(linkData.expiryDate);
              const formattedDate = date.toISOString().split("T")[0];
              setExpiryDate(formattedDate);
            }

            if (linkData.filterCondition) {
              const filterConditionObj = JSON.parse(linkData.filterCondition);

              setFilters((prev) => ({
                ...prev,
                itemType: filterConditionObj.itemType || "",
                design: filterConditionObj.design || "",
                grossWtMin: filterConditionObj.grossWtMin || "",
                grossWtMax: filterConditionObj.grossWtMax || "",
                netWtMin: filterConditionObj.netWtMin || "",
                netWtMax: filterConditionObj.netWtMax || "",
                finishtype_id: filterConditionObj.finishtype_id || "",
                screw_type_id: filterConditionObj.screw_type_id || "",
                from_date: filterConditionObj.from_date || "",
                to_date: filterConditionObj.to_date || "",
                imageFilter: filterConditionObj.imageFilter || "all",
              }));

              setIsSet(filterConditionObj.set || false);
              setIsExhibition(filterConditionObj.exhibition || false);

              // Set floor, collection, AND brand ✅
              setSelectedFloor(filterConditionObj.floor || null);
              setSelectedCollection(filterConditionObj.collection || null);
              setSelectedBrand(filterConditionObj.brand || null); // ✅ Add this line
            }

            if (
              linkData.type === "private" &&
              linkData.userAllowed &&
              groups.length > 0
            ) {
              const groupIds = linkData.userAllowed.map((id) => parseInt(id));
              const matchedGroups = groups.filter((group) =>
                groupIds.includes(group.id),
              );
              setSelectedGroup(matchedGroups);
            }

            setSnackbarOpen(true);
            setSnackbarMessage("Link data loaded successfully");
            setSnackbarSeverity("success");
          }
        } catch (error) {
          console.error("Error fetching link data:", error);
          setSnackbarOpen(true);
          setSnackbarMessage("Error loading link data");
          setSnackbarSeverity("error");
        } finally {
          setLoadingLinkData(false);
        }
      }
    };

    if (linkPrivacy === "public") {
      fetchLinkData();
      return;
    }

    if (groups.length > 0) {
      fetchLinkData();
    }
  }, [location.state, API_BASE_URL, groups]);

  // useEffect(() => {
  //   let savedTagNos = [];
  //   try {
  //     savedTagNos =
  //       filters.selectedStock && typeof filters.selectedStock === "string"
  //         ? JSON.parse(filters.selectedStock)
  //         : filters.selectedStock || [];
  //   } catch (error) {
  //     console.error("Error parsing selectedStock:", error);
  //   }
  //   setSelectedTagNos(new Set(savedTagNos));
  // }, [filters]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/auth/user-groups/${mfrId}`,
        );
        setGroups(res.data.data);
      } catch (err) {
        console.error("Error fetching groups:", err);
      }
    };

    const fetchBrandFloorAndCollection = async () => {
      try {
        const url = `${API_BASE_URL}/api/auth/brandfloorcollection/${mfrId}`;
        const { data } = await axios.get(url);
        setCollections(data?.data?.collections);
        setFloors(data.data.floors);
        setBrands(data.data.brands);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchGroups();
    fetchBrandFloorAndCollection();
  }, [mfrId]);

  // Auto-uncheck "Set" if collection is deselected
  useEffect(() => {
    if (!selectedCollection && isSet) {
      setIsSet(false);
    }
  }, [selectedCollection, isSet]);

  const handleChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // const handleDropdownChange = (name, newValue) => {
  //   name === "collection"
  //     ? // Use collection name not ID for collection filter
  //       setFilters((prev) => ({
  //         ...prev,
  //         [name]: newValue ? newValue.c_name : "",
  //       }))
  //     : // Use ID for rest filters
  //       setFilters((prev) => ({
  //         ...prev,
  //         [name]: newValue ? (newValue.id ? newValue.id : newValue.Id) : "",
  //       }));
  // };
  const handleDropdownChange = (name, newValue) => {
    if (name === "collection") {
      // Use collection name not ID for collection filter
      setFilters((prev) => ({
        ...prev,
        [name]:
          newValue && newValue.c_name !== "No Selection" ? newValue.c_name : "",
      }));
    } else {
      // Use ID for rest filters
      setFilters((prev) => ({
        ...prev,
        [name]:
          newValue &&
          newValue.id !== "no-selection" &&
          newValue.Id !== "no-selection"
            ? newValue.id
              ? newValue.id
              : newValue.Id
            : "",
      }));
    }
  };

  // 2. Create a "No Selection" option constant
  const NO_SELECTION_OPTION = {
    id: "no-selection",
    name: "No Selection",
  };

  const NO_SELECTION_BRAND = {
    Id: "no-selection",
    name: "No Selection",
  };

  const NO_SELECTION_COLLECTION = {
    id: "no-selection",
    c_name: "No Selection",
  };

  // Search stocks below, based on the filters applied
  const handleSearch = async (page = 1) => {
    setTableLoading(true);
    setSearched(true);
    try {
      // ✅ Only send filters that have actual values
      const payload = {
        store_id: mfrId,
        page,
        pageSize,
      };

      // Add filters only if they have values
      if (filters.itemType) payload.itemType = filters.itemType;
      if (filters.design) payload.design = filters.design;
      if (filters.screw_type_id) payload.screw_type_id = filters.screw_type_id;
      if (filters.finishtype_id) payload.finishtype_id = filters.finishtype_id;
      if (filters.grossWtMin) payload.grossWtMin = filters.grossWtMin;
      if (filters.grossWtMax) payload.grossWtMax = filters.grossWtMax;
      if (filters.netWtMin) payload.netWtMin = filters.netWtMin;
      if (filters.netWtMax) payload.netWtMax = filters.netWtMax;
      if (filters.from_date) payload.from_date = filters.from_date;
      if (filters.to_date) payload.to_date = filters.to_date;
      if (filters.expiryDate) payload.expiryDate = filters.expiryDate;

      // ✅ Add brand, floor, collection
      if (selectedBrand) payload.brand = selectedBrand;
      if (selectedFloor) payload.floor = selectedFloor;
      if (selectedCollection) payload.collection = selectedCollection;

      const response = await axios.post(
        `${API_BASE_URL}/api/fetchorder/getStockByFilters`,
        payload,
      );

      const {
        data: fetchedStockData,
        totalCount,
        selectedTagnos,
      } = response.data;

      setTableLoading(false);
      setStockData(fetchedStockData);
      setTotalCount(totalCount);
      setCurrentPage(page);
      setPosibleTagNos(selectedTagnos);

      const currentPageTagNos = fetchedStockData.map((item) => item.tagno);
      const allSelected = currentPageTagNos.every((tag) =>
        selectedTagNos.has(tag),
      );
      setSelectAll(allSelected);
    } catch (error) {
      console.error("Error fetching stock data:", error);
      setStockData([]);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    if (searched) handleSearch(1);
  }, [pageSize]);

  const handleSelectAllAcrossAllPages = () => {
    const allSelected = posibleTagNos.every((tag) => selectedTagNos.has(tag));
    if (allSelected) {
      // Remove all
      setSelectedTagNos(new Set());
    } else {
      // Select all
      setSelectedTagNos(new Set(posibleTagNos));
    }
  };

  const handleRowSelection = (tagno) => {
    setSelectedTagNos((prevSelected) => {
      const newSelected = new Set(prevSelected);
      newSelected.has(tagno)
        ? newSelected.delete(tagno)
        : newSelected.add(tagno);
      return newSelected;
    });
  };

  const truncate3 = (value) =>
    Number.isFinite(Number(value))
      ? Math.trunc(Number(value) * 1000) / 1000
      : 0;

  const handleSelectAll = () => {
    const currentPageTagNos = stockData.map((stock) => stock.tagno);
    setSelectedTagNos((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (selectAll) {
        currentPageTagNos.forEach((tagno) => newSelected.delete(tagno));
      } else {
        currentPageTagNos.forEach((tagno) => newSelected.add(tagno));
      }
      return newSelected;
    });
    setSelectAll(!selectAll);
  };

  // Empty the input fields of the form
  const resetForm = () => {
    setFilters({
      itemType: "",
      design: "",
      collection: "",
      floor: "",
      grossWtMin: "",
      grossWtMax: "",
      netWtMin: "",
      netWtMax: "",
      finishtype_id: "",
      screw_type_id: "",
      from_date: "",
      to_date: "",
      expiryDate: "",
      imageFilter: "all",
      store_id: mfrId,
    });

    setSelectedBrand(null); // ✅ Reset brand
    setSelectedFloor(null);
    setSelectedCollection(null);
    setSelectedGroup([]);
    setLinkName("");
    setIsSet(false);
    setIsExhibition(false);
    setExpiryDate("");

    setSelectedTagNos(new Set());
    setSelectAll(false);
    setSearched(false);
    setStockData([]);
    setTotalCount(0);
    setCurrentPage(1);

    setIsEditMode(false);
    setEditLinkInfo(null);
  };

  useEffect(() => {
    const currentPageTagNos = stockData.map((item) => item.tagno);
    const allSelected = currentPageTagNos.every((tag) =>
      selectedTagNos.has(tag),
    );
    setSelectAll(allSelected);
  }, [selectedTagNos, stockData]);

  const isSelectAllBtnDisabled =
    !Array.isArray(posibleTagNos) || posibleTagNos.length === 0;

  // Build a plain object of filter conditions (not an array)
  const buildFilterConditionObject = () => {
    const conditionObj = {};

    Object.entries(filters).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        key !== "store_id"
      ) {
        conditionObj[key] = value;
      }
    });

    // ✅ Add set flag properly
    if (isSet) {
      conditionObj["set"] = true;
    }

    if (isExhibition) {
      conditionObj["exhibition"] = true;
    }

    if (selectedFloor) {
      conditionObj["floor"] = selectedFloor;
    }

    if (selectedCollection) {
      conditionObj["collection"] = selectedCollection;
    }

    if (selectedBrand) {
      conditionObj["brand"] = selectedBrand;
    }

    return conditionObj;
  };

  // Show the designs based on the selected item type
  const filteredDesigns = filters.itemType
    ? designs.filter((design) => design.itemtype_id === filters.itemType)
    : designs;

  // Create/Edit link handler that sends filterCondition as a stringified object
  const createOrEditLinkHandler = async () => {
    if (linkName === "") {
      setSnackbarOpen(true);
      setSnackbarMessage("Please enter link name");
      setSnackbarSeverity("error");
      return;
    }
    if (linkType === "Private" && selectedGroup.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMessage("Please select at least 1 user group");
      setSnackbarSeverity("error");
      return;
    }

    if (loading) return;
    setLoading(true);

    try {
      let finalExpiryDate;
      if (expiryDate) {
        finalExpiryDate = new Date(expiryDate).toISOString();
      } else {
        const oneYearLater = new Date();
        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
        oneYearLater.setHours(23, 59, 59, 0);
        finalExpiryDate = oneYearLater.toISOString();
      }

      const filterConditionObject = buildFilterConditionObject();
      const filterConditionString = JSON.stringify(filterConditionObject);

      const groupAllowed =
        linkType === "Private" ? selectedGroup.map((g) => g.id) : [];

      const userAllowed = groupAllowed.map(String);

      const payload = {
        name: linkName,
        filterCondition: filterConditionString,
        userAllowed,
        expiryDate: finalExpiryDate,
        type: linkType.toLowerCase(),
        mfr_id: mfrId,
        set: isSet,
      };

      let response;
      if (isEditMode && editLinkInfo) {
        // Edit existing link
        response = await axios.patch(
          `${API_BASE_URL}/api/auth/links/${editLinkInfo}`,
          payload,
        );
      } else {
        // Create new link
        response = await axios.post(
          `${API_BASE_URL}/api/auth/createlink`,
          payload,
        );
      }

      if (!response.data?.success) throw response.data;

      setSnackbarOpen(true);
      setSnackbarMessage(
        isEditMode ? "Link updated successfully" : "Link created successfully",
      );
      setSnackbarSeverity("success");

      // Navigate back after successful operation
      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.error(
        `Error ${isEditMode ? "updating" : "creating"} link:`,
        error,
      );
      setSnackbarOpen(true);
      setSnackbarMessage(
        error.statusCode === 409
          ? `${error.message}`
          : `Error ${isEditMode ? "updating" : "creating"} link`,
      );
      setSnackbarSeverity("error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "#394A5C",
        minHeight: "100vh",
        p: { xs: 2, sm: 6 },
      }}
    >
      {/* Navigate Home & Navigate Back Buttons */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 1,
          mb: 2,
        }}
      >
        {/* Back Button */}
        <Box
          sx={{
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 3,
            bgcolor: "#FFF",
            p: 0.5,
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: "#e0e0e0",
              "& svg": {
                fill: "#056b05ff",
              },
            },
          }}
        >
          <ArrowBackIosNewRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              fontSize: 20,
              fill: "#42A996",
              transition: "all 0.2s ease",
            }}
          />
        </Box>

        {/* Home Button */}
        <Box
          sx={{
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 3,
            bgcolor: "#FFF",
            p: 0.5,
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
              bgcolor: "#e0e0e0",
              "& svg": {
                fill: "#056b05ff",
              },
            },
          }}
        >
          <HomeRoundedIcon
            onClick={() => navigate("/admin-dash")}
            sx={{
              fontSize: 20,
              fill: "#42A996",
              transition: "all 0.2s ease",
            }}
          />
        </Box>
      </Box>

      {/* Main Heading */}
      <Typography
        sx={{
          color: "#fff",
          fontSize: { xs: 22, sm: 32 },
          fontWeight: 600,
          mb: { xs: 2, sm: 4 },
        }}
      >
        {isEditMode ? "Edit Link" : "Create Link"}
      </Typography>

      {/* Create Filter Container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          bgcolor: "#1E2F40",
          borderRadius: 2,
          p: { xs: 1, sm: 3 },
          mt: 2,
        }}
      >
        {/* Set, Exhibition Checkboxes & Link Privacy */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1, sm: 4 },
            mb: 2,
          }}
        >
          {[
            {
              label: "Set",
              checked: isSet,
              onChange: (e) => setIsSet(e.target.checked),
              disabled: !selectedCollection, // ✅ Add disabled property
            },
            {
              label: "Exhibition",
              checked: isExhibition,
              onChange: (e) => setIsExhibition(e.target.checked),
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                opacity: item.disabled ? 0.5 : 1, // ✅ Add visual feedback
              }}
            >
              <Checkbox
                checked={item.checked}
                onChange={item.onChange}
                disabled={item.disabled} // ✅ Add this line
                sx={{
                  color: "white",
                  "&.Mui-checked": { color: "#42A996" },
                  "&.Mui-disabled": {
                    // ✅ Add disabled styling
                    color: "rgba(255, 255, 255, 0.3)",
                  },
                }}
              />
              <Typography
                sx={{
                  color: "white",
                  fontWeight: 500,
                  opacity: item.disabled ? 0.5 : 1, // ✅ Dim the label too
                }}
              >
                {item.label}
              </Typography>
            </Box>
          ))}

          {/* Privacy & Group Selector */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1,
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography sx={{ color: "white" }}>Privacy:</Typography>
              <FormControl
                sx={{
                  ...whiteTextFieldStyles,
                  minWidth: { xs: "100%", sm: 120 },

                  "& .MuiInputBase-root": {
                    minHeight: 44,
                    height: "auto",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              >
                <Select
                  value={linkType}
                  onChange={(e) => setLinkType(e.target.value)}
                >
                  <MenuItem value="Public">Public</MenuItem>
                  <MenuItem value="Private">Private</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Collapse
              sx={{ flex: 1 }}
              in={linkType === "Private"}
              timeout={400}
              unmountOnExit
            >
              <Autocomplete
                multiple
                disablePortal
                disableClearable
                options={groups}
                getOptionLabel={(option) => option.group_name}
                value={selectedGroup}
                onChange={(e, newValue) => setSelectedGroup(newValue)}
                filterOptions={(x) => x}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Typography
                      key={option.id}
                      sx={{
                        backgroundColor: "#42A996",
                        color: "white",
                        borderRadius: 1,
                        // px: 1,
                        // py: 0.25,
                        fontSize: 12,
                        whiteSpace: "nowrap",
                        // mx: 0.25,
                      }}
                      {...getTagProps({ index })}
                    >
                      {option.group_name}
                    </Typography>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      selectedGroup.length === 0 ? "Select Groups" : ""
                    }
                    variant="outlined"
                    sx={{
                      ...whiteTextFieldStyles,

                      // IMPORTANT: allow height to expand
                      "& .MuiInputBase-root": {
                        height: "auto",
                        // minHeight: 44,
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                      },

                      "& .MuiAutocomplete-tag": {
                        margin: "4px",
                      },
                    }}
                    InputProps={{ ...params.InputProps, readOnly: true }}
                  />
                )}
              />
            </Collapse>
          </Box>
        </Box>

        {/* Link Name, Expiry & Privacy */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          {/* Name & Expiry */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              flex: 1,
            }}
          >
            <TextField
              placeholder="Link Name"
              variant="outlined"
              value={linkName}
              onChange={(e) => setLinkName(e.target.value)}
              sx={{
                ...whiteTextFieldStyles,
                flex: 1,
                minWidth: { xs: "100%", sm: "auto" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LinkIcon
                      style={{ color: "white", width: 20, height: 20 }}
                    />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Expiry Date"
              type="date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{
                ...whiteTextFieldStyles,
                minWidth: { xs: "100%", sm: 150 },
                flex: 1,
              }}
            />
          </Box>
        </Box>

        {/* Brand, Floor & Collection */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
          }}
        >
          {[
            {
              placeholder: "Select brand",
              value: selectedBrand,
              options: [NO_SELECTION_BRAND, ...brands],
              onChange: setSelectedBrand,
              keyField: "Id",
              labelField: "name",
            },
            {
              placeholder: "Select floor",
              value: selectedFloor,
              options: [NO_SELECTION_BRAND, ...floors],
              onChange: setSelectedFloor,
              keyField: "Id",
              labelField: "name",
            },
            {
              placeholder: "Select collection",
              value: selectedCollection,
              options: [NO_SELECTION_COLLECTION, ...collections],
              onChange: setSelectedCollection,
              keyField: "id",
              labelField: "c_name",
            },
          ].map((item, i) => (
            <Box
              key={i}
              sx={{ flex: { xs: "1 1 100%", md: i === 2 ? 2.05 : 1 } }}
            >
              <Autocomplete
                disablePortal
                disableClearable
                options={item.options}
                getOptionLabel={(option) => option[item.labelField] || ""}
                value={
                  item.options.find((o) => o[item.keyField] === item.value) ||
                  null
                }
                onChange={(e, newValue) => {
                  if (newValue && newValue[item.keyField] === "no-selection") {
                    item.onChange(null);
                  } else {
                    item.onChange(newValue ? newValue[item.keyField] : null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={item.placeholder}
                    variant="outlined"
                    sx={{ ...whiteTextFieldStyles, width: "100%" }}
                    InputProps={{ ...params.InputProps, readOnly: true }}
                  />
                )}
              />
            </Box>
          ))}
        </Box>

        {/* Filter Fields (Item Type, Design, Weights) */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {[
            {
              label: "Item Type",
              value: filters.itemType,
              options: [NO_SELECTION_OPTION, ...itemtypes],
              field: "itemType",
            },
            {
              label: "Design",
              value: filters.design,
              options: [NO_SELECTION_OPTION, ...filteredDesigns],
              field: "design",
            },
            {
              label: "Gross Wt Min",
              value: filters.grossWtMin,
              type: "number",
              field: "grossWtMin",
            },
            {
              label: "Gross Wt Max",
              value: filters.grossWtMax,
              type: "number",
              field: "grossWtMax",
            },
            {
              label: "Net Wt Min",
              value: filters.netWtMin,
              type: "number",
              field: "netWtMin",
            },
            {
              label: "Net Wt Max",
              value: filters.netWtMax,
              type: "number",
              field: "netWtMax",
            },
          ].map((item, i) => (
            <Grid item xs={12} sm={i < 2 ? 6 : 3} md={i < 2 ? 3 : 1.5} key={i}>
              {item.options ? (
                <Autocomplete
                  disablePortal
                  disableClearable
                  options={item.options}
                  getOptionLabel={(option) => option.name}
                  value={item.options.find((o) => o.id === item.value) || null}
                  onChange={(e, newValue) =>
                    handleDropdownChange(item.field, newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={`Select ${item.label}`}
                      variant="outlined"
                      sx={{ ...whiteTextFieldStyles, width: "100%" }}
                      InputProps={{ ...params.InputProps, readOnly: true }}
                    />
                  )}
                />
              ) : (
                <TextField
                  placeholder={item.label}
                  type={item.type || "text"}
                  name={item.field}
                  value={item.value}
                  onChange={handleChange}
                  fullWidth
                  sx={whiteTextFieldStyles}
                />
              )}
            </Grid>
          ))}
        </Grid>

        {/* From/To Dates, Select/Remove All, Search */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            mb: 2,
          }}
        >
          {["from_date", "to_date"].map((field, i) => (
            <TextField
              key={field}
              label={field === "from_date" ? "From Date" : "To Date"}
              type="date"
              name={field}
              value={filters[field]}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{ ...whiteTextFieldStyles, flex: 1 / 3.05 }}
            />
          ))}

          <Box
            onClick={
              isSelectAllBtnDisabled ? undefined : handleSelectAllAcrossAllPages
            }
            sx={{
              height: 44,
              // minWidth: { sm: 275 },
              width: { xs: "100%", sm: "auto" },
              px: 2,
              bgcolor: "#FFF",
              borderRadius: 2,
              display: "flex",

              alignItems: "center",
              justifyContent: "center",
              cursor: isSelectAllBtnDisabled ? "not-allowed" : "pointer",
              opacity: isSelectAllBtnDisabled ? 0.6 : 1,
              pointerEvents: isSelectAllBtnDisabled ? "none" : "auto",
              border: "1px solid #ccc",
              transition: "0.2s ease",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                color: isSelectAllBtnDisabled ? "#aaa" : "#42A996",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {Array.isArray(posibleTagNos) &&
              posibleTagNos.length > 0 &&
              posibleTagNos.every((tag) => selectedTagNos.has(tag))
                ? "Remove all"
                : "Select all across all pages"}
            </Typography>
          </Box>

          <Box
            onClick={() => handleSearch(1)}
            sx={{
              height: 44,
              width: { xs: "100%", sm: "auto" },
              bgcolor: "#42A996",
              borderRadius: 2,
              px: 2,

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FFF",
              cursor: "pointer",
            }}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                Search
              </Typography>
            )}
          </Box>
        </Box>

        {/* ------------------------- */}
        {/* 6th Row - Selected Stocks Table and Pagination */}
        {/* ------------------------- */}
        <Box sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
          {searched && (
            <>
              {tableLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 6,
                  }}
                >
                  <CircularProgress color="primary" />
                  <Typography sx={{ mt: 2, color: "white", fontWeight: 500 }}>
                    Searching stock data...
                  </Typography>
                </Box>
              ) : stockData.length > 0 ? (
                <TableContainer component={Paper} sx={{ mt: 2, minWidth: 650 }}>
                  {/* Select All On Current Page Button */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      ml: 2,
                    }}
                  >
                    <IconButton onClick={handleSelectAll}>
                      {selectAll ? (
                        <CheckBox color="primary" />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}
                    </IconButton>
                    <Typography sx={{ color: "black" }}>
                      Select all on current page
                    </Typography>
                  </Box>

                  {/* Products Table */}
                  <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Tag No</TableCell>
                        <TableCell>Item Type</TableCell>
                        <TableCell>Design</TableCell>
                        <TableCell>Metal Type</TableCell>
                        <TableCell>Purity</TableCell>
                        <TableCell>Gross Weight</TableCell>
                        <TableCell>Image</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {stockData.map((stock, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <IconButton
                              onClick={() => handleRowSelection(stock.tagno)}
                            >
                              {selectedTagNos.has(stock.tagno) ? (
                                <CheckBox color="primary" />
                              ) : (
                                <CheckBoxOutlineBlank />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {stock.tagno_alpha || stock.tagno}
                          </TableCell>
                          <TableCell>{stock.itemtype_name}</TableCell>
                          <TableCell>{stock.design_name}</TableCell>
                          <TableCell>{stock.metaltype_name}</TableCell>
                          <TableCell>{stock.purity_name}</TableCell>
                          <TableCell>{truncate3(stock.gross)}</TableCell>
                          <TableCell>
                            <img
                              src={`${IMAGE_BASE_URL}${
                                stock.tagno_alpha || stock.tagno
                              }.jpg`}
                              alt="Stock Item"
                              style={{
                                width: 50,
                                height: 50,
                                objectFit: "cover",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography mt={2} sx={{ color: "white" }}>
                  No stock found with applied filters
                </Typography>
              )}
            </>
          )}
        </Box>

        {/* ------------------------- */}
        {/* Pagination */}
        {/* ------------------------- */}
        {totalCount > 0 && (
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{ mt: 2, flexWrap: "wrap", gap: 1 }}
          >
            {/* Rows per page */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography sx={{ color: "white" }}>Rows per page:</Typography>
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                  sx={{
                    color: "white",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    "& .MuiSvgIcon-root": { color: "white" },
                  }}
                >
                  {[10, 25, 50, 100].map((size) => (
                    <MenuItem key={size} value={size}>
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Pagination */}
            <Pagination
              count={Math.ceil(totalCount / pageSize)}
              page={currentPage}
              onChange={(event, value) => handleSearch(value)}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": { color: "white" },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "white",
                  color: "black",
                },
              }}
            />
          </Grid>
        )}
      </Box>

      {/* Create Link Button */}
      <Box
        onClick={!loading ? createOrEditLinkHandler : undefined}
        sx={{
          textAlign: "center",
          fontWeight: 600,
          color: "#FFF",
          bgcolor: loading ? "#7bbdb1" : "#42A996",
          px: 1.5,
          py: 1,
          borderRadius: 1,
          width: 140,
          mt: 2,
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.8 : 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          transition: "0.2s ease",
        }}
      >
        {loading ? (
          <>
            <CircularProgress size={18} sx={{ color: "white" }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {isEditMode ? "Updating..." : "Creating..."}
            </Typography>
          </>
        ) : isEditMode ? (
          "Update Link"
        ) : (
          "Create Link"
        )}
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          "&.MuiSnackbar-root": {
            bottom: "100px !important", // force override snackbar position
          },
        }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Common white TextField styles
const whiteTextFieldStyles = {
  "& .MuiInputLabel-root": {
    color: "white",
  },

  "& .MuiInputBase-root": {
    backgroundColor: "#1E2F40", // dark background for all input roots
    color: "white",
    height: 44,
  },

  "& .MuiInputBase-input": {
    color: "white",
  },

  "& .MuiOutlinedInput-root": {
    backgroundColor: "#1E2F40", // ensures consistency for all outlined inputs
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },

    // Keeps input text white even when focused/filled
    "& input": {
      color: "white",
      Padding: 10,
    },

    // Makes date picker icon white
    "& input[type='date']::-webkit-calendar-picker-indicator": {
      filter: "invert(1)",
    },
  },

  // Ensures all dropdown icons, arrows, and adornments stay white
  "& .MuiSvgIcon-root": {
    color: "white",
  },

  // Menu styling for Select & Autocomplete dropdowns
  "& .MuiPaper-root": {
    backgroundColor: "#1E2F40",
    color: "white",
  },
};

export default CreateFilterLink;
